//import React from "react";
//import ResourceLinks from "gatsby-theme-carbon/src/components/LeftNav/ResourceLinks";

//const links = [];

// shouldOpenNewTabs: true if outbound links should open in a new tab
// <ResourceLinks shouldOpenNewTabs links={links} />;
// Return null to remove hanging line
const CustomResources = () => null;

export default CustomResources;
